import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MarketPage,PendingNodes, Nodes, RequestPermission, RequestPermissionOpen, AdminPermission,AdminPermissionReady, Auth, UserPage } from '../pages/admin';
import { AdminLayout, ClientLayout } from '../layouts';
import { useAuth } from '../hooks';
 //<Route path='/*' element={< Auth />} /> 
export function AdminRouter() {
  const { user } = useAuth();

  const loadLayout = (Layout, Page) => {
    return (
      <Layout >
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
        {!user ? (
       <>

        <Route path='/' element={< Auth />} />
          <Route path='/market' element={< Auth />} />
          <Route path='/nodes/:statusNodes' element={< Auth />} />
          <Route path='/nodesPending/:statusNodes' element={< Auth />} />
          <Route path='/requestPermissionMain' element={loadLayout(ClientLayout, RequestPermission)} />
          <Route path='/requestPermissionOpen' element={loadLayout(ClientLayout, RequestPermissionOpen)} />
          <Route path='/adminPermission' element={< Auth />} />
          <Route path='/user' element={< Auth />} />
          </>
        ) : (
        <>
          <Route path='/' element={< AdminLayout />} />
          <Route path='/market' element={loadLayout(AdminLayout, MarketPage)} />
          <Route path='/nodes/:statusNodes' element={loadLayout(AdminLayout, Nodes)} />
          <Route path='/nodesPending/:statusNodes' element={loadLayout(AdminLayout, PendingNodes)} />
      
          <Route path='/adminRequestPermissionMain' element={loadLayout(AdminLayout, RequestPermission)} />
          <Route path='/adminRequestPermissionOpen' element={loadLayout(AdminLayout, RequestPermissionOpen)} />
          <Route path='/requestPendingPermission/:statusRequest' element={loadLayout(AdminLayout, AdminPermission)} />
          <Route path='/requestReadyPermission/:statusRequest' element={loadLayout(AdminLayout, AdminPermissionReady)} />
          <Route path='/user' element={loadLayout(AdminLayout, UserPage)} />
        </>
        )}
    </Routes>
  );
}
